/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$bottom-drawer-default-radius: 0 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  font-family: $font-family-base;
}

$transition-duration: 300ms;
$transition-timing-function: cubic-bezier(0.33, 0, 0.35, 1);

.#{$prefix}bottom-drawer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  z-index: 100;

  &::before {
    content: "";
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  }

  &.#{$prefix}bottom-drawer-open {
    top: 0;
    height: 100%;
    display: flex;
    align-items: flex-end;
    pointer-events: all;

    &::before {
      opacity: 1;
      visibility: visible;
      transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
    }

    .#{$prefix}bottom-drawer-wrapper {
      bottom: 0;
      transform: translateY(0);

      eon-ui-icon {
        transform: rotate(180deg);
      }
    }
  }
}

.#{$prefix}bottom-drawer-wrapper {
  width: 100%;
  top: 0;
  transform: translateY(calc(100% - 48px));
  transition: transform $transition-timing-function $transition-duration;
  margin-top: -48px;
  max-height: 100vh;
  pointer-events: all;
  overflow: hidden;
  border-radius: $bottom-drawer-default-radius;

  @include for-size(tablet) {
    transform: translateY(calc(100% - 55px));
    max-height: 75vh;
    margin-top: -55px;
  }

  @include for-size(desktop-or-larger) {
    transform: translateY(calc(100% - 65px));
    max-height: 60vh;
    margin-top: -65px;
  }

  eon-ui-icon {
    color: v(textColor);
    margin-left: 16px;
    transform: rotate(0deg);
    transition: transform $transition-timing-function $transition-duration;
  }
}

.#{$prefix}bottom-drawer-header {
  background: v(backgroundColor);
  cursor: pointer;
  height: 48px;

  @include for-size(tablet-or-larger) {
    height: 55px;
  }

  @include for-size(desktop-or-larger) {
    height: 65px;
  }
}

.#{$prefix}bottom-drawer-header-wrapper {
  display: flex;
  color: v(textColor);
  font-size: 18px;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding: 0 24px;
  max-width: var(--maxContentWidth);
  margin: 0 auto;

  &:focus {
    outline: none;
  }

  &-centered {
    justify-content: center;
  }

  &-large-screen {
    padding: 0;

    .#{$prefix}bottom-drawer-header-content {
      right: -112px;
      position: relative;
    }
  }
}

.#{$prefix}bottom-drawer-header-content {
  display: flex;
  align-items: center;
}

.#{$prefix}bottom-drawer-content {
  overflow: auto;
  max-height: calc(100vh - 48px);

  @include for-size(tablet-or-larger) {
    max-height: calc(75vh - 55px);
  }

  @include for-size(desktop-or-larger) {
    max-height: calc(60vh - 65px);
  }
}

::slotted(*) {
  @include eon-typography(copy);

  margin-bottom: 24px;

  @include for-size(phone) {
    margin-bottom: 13px;
  }
}

::slotted(*:last-child) {
  margin-bottom: 0;
}
